import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Document } from '../_models/document';

@Injectable()
export class DocumentService {
  private apiBaseUrl = environment.apiBaseUrl;
  documentList$: BehaviorSubject<Array<Document>> = new BehaviorSubject<Array<Document>>([]);

  constructor(private http: HttpClient) {}

  getDocuments(): Observable<Document[]> {
    return this.http.get<any>(this.apiBaseUrl + 'api/private/v1/documents').pipe(
      map((response) => {
        if (response) {
          if (response) {
            this.documentList$.next(response);
            return response;
          }
        }
      })
    );
  }

  getDocument(id: number): Observable<Document> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/documents/' + id)
      .pipe(map((response) => response));
  }

  saveDocument(documentItem): Observable<Document> {
    const document = { ...documentItem };
    delete document.lastUpdated;
    delete document.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    document.companyId = companySelected ? companySelected.id : null;

    if (document.user != null && document.user.id != null) {
      document.user = { id: document.user.id };
    }
    if (document.id) {
      return this.http
        .put<Document>(this.apiBaseUrl + 'api/private/v1/documents/' + document.id, document)
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<Document>(this.apiBaseUrl + 'api/private/v1/documents/', document)
        .pipe(map((response) => response));
    }
  }

  deleteDocument(document: Document): Observable<Document> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/documents/' + document.id).pipe(
      map((response) => {
        if (response) {
          if (response) {
            this.getDocuments().subscribe();
            return { id: document.id } as Document;
          }
        }
      })
    );
  }
}
